export type Topic = {
  id: string;
  name: string;
  tagline: string;
  description: string;
  icon: string;
};

export const topics: Topic[] = [
  {
    id: "score",
    name: "评分猫腻",
    tagline: "拆解分数是怎么被算出来的",
    description:
      "从权重设置、分项口径到同分处理，逐项核对评分表里那些容易被忽略却能改写名次的细节。",
    icon: "ri-scales-3-line",
  },
  {
    id: "deal",
    name: "幕后交易",
    tagline: "评委与赞助的关系网",
    description:
      "梳理评委来源、赞助席位与回避机制的缺口，看看结果在开赛之前被哪些因素影响。",
    icon: "ri-hand-coin-line",
  },
  {
    id: "cold",
    name: "爆冷瞬间",
    tagline: "现场回放里的时间差",
    description:
      "对着直播回放逐帧复盘，从举牌、复核到念名字，找出那些不合常理的时间缝隙。",
    icon: "ri-flashlight-line",
  },
  {
    id: "vote",
    name: "网络票选",
    tagline: "人气奖的数据成色",
    description:
      "分析票数曲线、设备指纹与剔除规则，判断人气奖到底是民意还是批量操作的结果。",
    icon: "ri-bar-chart-2-line",
  },
  {
    id: "rule",
    name: "合约规则",
    tagline: "条款如何决定表态时机",
    description:
      "从保密期、违约金到退赛声明的时间点，看合约如何塑造选手对外说出的每一句话。",
    icon: "ri-file-text-line",
  },
];

export const getTopicName = (id: string): string => {
  const found = topics.find((topic) => topic.id === id);
  return found ? found.name : "综合爆料";
};